<div class="modal-box tech-request-modal" cdkDrag>
  <form class="tech-request-modal__form" [formGroup]="techForm" (ngSubmit)="onSubmit()" id="tech-form">
    <div class="modal-header tech-request-modal__header" cdkDragHandle>
        <div class="tech-request-modal__headline">
            <span class="tech-request-modal__eyebrow">{{ 'FORMS' | translate }}</span>
            <h4 class="modal-title tech-request-modal__title">{{ 'TECH_REQUEST' | translate }}</h4>
        </div>
        <button type="button" class="tech-request-modal__close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
    <div class="modal-body tech-request-modal__body">
        <section class="tech-request-modal__panel tech-request-modal__panel--wide">
            <div class="tech-request-modal__stack">
                <div class="tech-request-modal__field">
                    <label class="tech-request-modal__label">{{ 'ASSIGN_TO' | translate }}*</label>
                    <ng-select [clearable]="false" [attr.aria-label]="'SELECT_A_USER_TO_ASSIGN_TO' | translate"
                        [ngClass]="{ 'is-invalid': techForm.get('AssignTo')?.touched && techForm.get('AssignTo')?.invalid }"
                        bindLabel="fullName" bindValue="id" [items]="techUsers" formControlName="AssignTo">
                    </ng-select>
                    <div *ngIf="techForm.get('AssignTo')?.invalid && techForm.get('AssignTo')?.touched" class="tech-request-modal__feedback">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                </div>
                <div class="tech-request-modal__grid tech-request-modal__grid--campaign">
                    <div class="tech-request-modal__field">
                        <label class="tech-request-modal__label">{{ 'CLIENT_OPTIONAL' | translate }}</label>
                        <ng-select [clearable]="true" [attr.aria-label]="'SELECT_A_CLIENT' | translate" bindLabel="fullName" bindValue="id" [items]="allClients" formControlName="clientId">
                        </ng-select>
                    </div>
                    <div class="tech-request-modal__field tech-request-modal__field--span-2">
                        <label class="tech-request-modal__label">{{ 'CAMPAIGN_OPTIONAL' | translate }}</label>
                        <ng-select [clearable]="true" [attr.aria-label]="'SELECT_A_CAMPAIGN' | translate"
                            [ngClass]="{ 'is-invalid': techForm.get('campaignId')?.touched && techForm.get('campaignId')?.invalid }"
                            bindLabel="name" bindValue="id" [items]="campaignsData" formControlName="campaignId">
                        </ng-select>
                    </div>
                </div>
            </div>
        </section>
        <section class="tech-request-modal__panel tech-request-modal__panel--wide">
            <div class="tech-request-modal__stack">
                <div class="tech-request-modal__field">
                    <label class="tech-request-modal__label">{{ 'TASK_TITLE' | translate }}*</label>
                    <input type="text" class="form-control tech-request-modal__control" formControlName="Title" />
                    <div *ngIf="techForm.get('Title')?.invalid && techForm.get('Title')?.touched" class="tech-request-modal__feedback">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                </div>
                <div class="tech-request-modal__field">
                    <label class="tech-request-modal__label">{{ 'REQUEST' | translate }}*</label>
                    <textarea class="form-control tech-request-modal__control tech-request-modal__control--textarea" rows="4" formControlName="Request"></textarea>
                    <div *ngIf="techForm.get('Request')?.invalid && techForm.get('Request')?.touched" class="tech-request-modal__feedback">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                </div>
                <div class="tech-request-modal__field">
                    <label class="tech-request-modal__label">{{ 'RESPONSE_EMAIL' | translate }}* ({{ 'RESPONSE_EMAIL_HELP' | translate }})</label>
                    <input type="email" class="form-control tech-request-modal__control" formControlName="ResponseEmail" />
                    <div *ngIf="techForm.get('ResponseEmail')?.invalid && techForm.get('ResponseEmail')?.touched" class="tech-request-modal__feedback">{{ 'VALID_EMAIL_REQUIRED' | translate }}</div>
                </div>
            </div>
        </section>
    </div>
    <div class="modal-footer tech-request-modal__footer" cdkDragHandle>
        <div class="tech-request-modal__actions">
            <button class="red-outline-button tech-request-modal__button" type="button" (click)="close()">{{ 'CANCEL' | translate }}</button>
            <button class="blue-button tech-request-modal__button" id="submit-change-tech" type="submit" [disabled]="techForm.invalid || techForm.disabled">{{ 'SUBMIT' | translate }}</button>
        </div>
    </div>
  </form>
</div>
